import type { ChatAttachment } from '@/services/api/domains/chatbot.api'

import { MAX_ATTACHMENT_DATA_URL_CHARS } from './attachment-limits'

/** The combined length of every data URL a turn would send. */
export function attachmentDataUrlChars(attachments: readonly ChatAttachment[], image?: string | null): number {
  return attachments.reduce((sum, a) => sum + a.dataUrl.length, image ? image.length : 0)
}

/** True when the turn would carry more attachment bytes than the chat routes accept. */
export function exceedsAttachmentBudget(attachments: readonly ChatAttachment[], image?: string | null): boolean {
  return attachmentDataUrlChars(attachments, image) > MAX_ATTACHMENT_DATA_URL_CHARS
}
